import { MetaReducer } from '@ngrx/store';
import * as fromAuth from './auth.reducer';
import { routerReducer } from '@ngrx/router-store';
import { AppState } from '../app.state';
import { environment } from 'src/environments/environment';
import * as fromShared from './shared.reducer';
import * as fromAccount from './account.reducer';
import * as fromAddress from './address.reducer';
import * as fromImage from './image.reducer';
import * as fromOrganization from './organization.reducer';
import * as fromTokens from './tokens.reducer';
import * as fromRide from './ride.reducer';
import * as fromOrder from './order.reducer';
import * as fromPasses from './passes.reducer';
import * as fromPremiumRide from './premium-ride.reducer';
import * as fromHistory from './history.reducer';

export const reducers = {
  auth: fromAuth.reducer,
  shared: fromShared.reducer,
  router: routerReducer,
  account: fromAccount.reducer,
  address: fromAddress.reducer,
  image: fromImage.reducer,
  organization: fromOrganization.reducer,
  tokens: fromTokens.reducer,
  ride: fromRide.reducer,
  order: fromOrder.reducer,
  passes: fromPasses.reducer,
  premiumRide: fromPremiumRide.reducer,
  history: fromHistory.reducer
};

export const metaReducers: MetaReducer<AppState>[] = !environment.production
  ? []
  : [];
